import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is via httpOnly Secure SameSite=None cookie set by the backend.
// The browser attaches it automatically thanks to withCredentials=true.
// No token is ever stored in localStorage (XSS-safe).
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Non-destructive response handling.
 *
 * We DO NOT auto-redirect on 401 — that has caused false "auto-logout"
 * experiences when a single background call transiently fails. Instead we:
 *   - Silently swallow 401s on /auth/me (expected while logged out).
 *   - Return a never-settling promise for any other 401 so no runtime
 *     error overlay appears. AuthContext's checkAuth still runs, so
 *     the app will naturally show the login screen when the session
 *     is truly invalid — but not because a single transient 401.
 *   - Every other error propagates normally.
 */
const AUTH_PROBE = ["/auth/me", "/auth/login", "/auth/logout"];

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401) {
      // Never surface a 401 as a runtime error, but never auto-logout either.
      if (AUTH_PROBE.some((p) => url.endsWith(p))) return Promise.reject(err);
      return new Promise(() => {}); // hang caller silently
    }
    return Promise.reject(err);
  }
);

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    if (reason?.isAxiosError && reason?.response?.status === 401) e.preventDefault();
  });
}
